import { React, useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import BackdropComponent from "../Spinner/Spinner";
import classes from "./CreateUpdateIdmRecord.module.css";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import SimCardDownloadOutlinedIcon from "@mui/icons-material/SimCardDownloadOutlined";
import NorthWestOutlinedIcon from "@mui/icons-material/NorthWestOutlined";
import SouthEastOutlinedIcon from "@mui/icons-material/SouthEastOutlined";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import WarningIcon from "@mui/icons-material/Warning";
import {
  Divider,
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  Autocomplete,
  IconButton,
  Tooltip,
  Box,
  Typography,
  Link,
  styled,
  Chip,
  FormControlLabel,
  Checkbox,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import applicationUsageLog from "../../utils/applicationUsagesLog";
import {
  getIdmRosterDetail,
  insertIdmCredential,
  updateIdmCredential,
  IdmCredentialLock,
} from "../../services/userServices";
import SnackBar from "components/SnackBar/SnackBar";
import PropTypes from "prop-types";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useDispatch } from "react-redux";
import { SnackBarStoreAction } from "Store/SnackBar";
import moment from "moment";
import NoRosterIdCreateUpdateIdmRecord from "./NoRosterIdCreateUpdateIdmRecord";
import { blue, red } from "@mui/material/colors";
import { Transition } from "components/Common/Header/Header";
import { CustomButton } from "components/RosterConfig/RosterConfigStyle";
import ServiceNowSection from "../ServiceNow/ServiceNowSection";
import { LimitChip, StyledChip } from "./NoRosterIdCreateUpdateIdmRecord";

const optionYesNo = ["Yes", "No"];
const optionTicketType = [
  { name: "Activation", color: "#6495ED" },
  { name: "Change Role", color: "#98FF98" },
  { name: "Expanded Role", color: "#FFD700" },
  { name: "Extend Access Date", color: "#008080" },
  { name: "ID Management Services", color: "#00FFFF" },
];

export const ReadOnlyTextFieldtheme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input.Mui-disabled": {
            color: "black",
            "-webkit-text-fill-color": "black",
            fontFamily: "Urbanist, Verdana, Arial, sans-serif",
          },
          "&.Mui-disabled": {
            color: "black",
            "-webkit-text-fill-color": "black",
          },
          "& .MuiFormLabel-root.Mui-disabled": {
            color: "black",
          },
          "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "black",
            },
        },
      },
    },
  },
});

export const initialRosterDetails = {
  selectedSite: null,
  selectedClient: null,
  selectedProjects: [],
  selectedTechDeploymentType: null,
  headCount: null,
  rosterLockDate: null,
  trainingStartDate: null,
  idmTeamLead: null,
  primaryIdmPoc: null,
};

export default function CreateUpdateIdmRecord(props) {
  const isUpdateMode = props?.trackingId > 0;
  const {
    idmRecordOpen,
    handleClose,
    trackingId,
    idmRosterDetails,
    idmTrackingDetails,
    systemImpacted,
    rosterId,
    switchType,
    sanityCheckNotes,
    issueDescription,
    isEdit,
  } = props;
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isNoClassRosterId, setIsNoClassRosterId] = useState(false);
  const [idmCredentialTrackingId, setIdmCredentialTrackingId] = useState(0);

  const [ticketType, setTicketType] = useState({ name: "", color: "" });
  const [impacted, setImpacted] = useState(0);
  const [askNowRITM, setAskNowRITM] = useState("");
  const [openedTAHC, setOpenedTAHC] = useState(null);
  const [selectedSwitchType, setSelectedSwitchType] = useState(null);

  const [ttecSwitchIdDate, setTtecSwitchIdDate] = useState(null);
  const [emailDate, setEmailDate] = useState(null);
  const [nonAutomatedQmsDate, setNonAutomatedQmsDate] = useState(null);
  const [ntLoginIsuDate, setNtLoginIsuDate] = useState(null);
  const [clientSwitchSubmissionDate, setClientSwitchSubmissionDate] =
    useState(null);
  const [clientAccessCalDate, setClientAccessCalDate] = useState(null);
  const [dateCheckedByTl, setDateCheckedByTl] = useState(null);
  const [clientIDSubmissionDate, setClientIDSubmissionDate] = useState(null);
  const [clientIDCompletionDate, setClientIDCompletionDate] = useState(null);
  const [clientSwitchCompletionDate, setClientSwitchCompletionDate] =
    useState(null);

  const [isLock, setIsLock] = useState();
  const [notes, setNotes] = useState("");
  const [idmChecklistURL, setIdmChecklistURL] = useState("");
  const [loading, setLoading] = useState(false);

  const [selectedRosterId, setSelectedRosterId] = useState(0);

  const [selectedsystemImpacted, setSelectedsystemImpacted] = useState([]);

  const [selectedSanityCheckNotes, setSelectedSanityCheckNotes] = useState([]);

  const [selectedIssueDescription, setSelectedIssueDescription] = useState([]);

  const [classRosterDetails, setClassRosterDetails] = useState({}); // Roster Details from API.

  const [isSiteTooltipOpen, setIsSiteTooltipOpen] = useState(false);
  const [isClientTooltipOpen, setIsClientTooltipOpen] = useState(false);
  const [isProjectTooltipOpen, setIsProjectTooltipOpen] = useState(false);
  const [isAskNowTooltipOpen, setIsAskNowTooltipOpen] = useState(false);
  const [rosterDetails, setRosterDetails] = useState(initialRosterDetails); //RosterDetails from User input.
  const [disableIsNoClassRosterId, setDisableIsNoClassRosterId] =
    useState(false);
  const [unSavedRosterChangesDialogOpen, setUnSavedRosterChangesDialogOpen] =
    useState(false);

  const dispatch = useDispatch();

  const showSnack = (message, severity) => {
    const obj = {
      open: true,
      message: message,
      severity: severity,
    };
    dispatch(SnackBarStoreAction.updateSnack(obj));
  };

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const setUpIdmCredentialFields = (idmTrackingDetails) => {
    if (!idmTrackingDetails) return;

    const {
      ClassRosterId,
      IDMCredentialTrackingId,
      TicketType,
      Impacted,
      AskNowTicketNumber,
      OpenedBy_TA_HC,
      IDMSwitchTypeId,
      TtecSwitchIdDate,
      EmailDate,
      NonAutomatedQMSDate,
      NTLoginISUCompletionDate,
      ClientSwitchSubmissionDate,
      ClientAccessCalculationDate,
      DateCheckedByTL,
      ClientIdSubmissionDate,
      ClientIdCompletionDate,
      ClientSwitchCompletionDate,
      Notes,
      SystemImpactedIds,
      IssueDescriptionIds,
      SanityCheckNotesIds,
      IDMCredentialTrackingURL,
      IsLocked,
    } = idmTrackingDetails;

    const systemImpactedIdList = SystemImpactedIds
      ? SystemImpactedIds.split(",")
      : [];
    const issueDescriptionIdList = IssueDescriptionIds
      ? IssueDescriptionIds.split(",")
      : [];
    const sanityCheckNotesIds = SanityCheckNotesIds
      ? SanityCheckNotesIds.split(",")
      : [];
    setSelectedRosterId({ ClassRosterId });
    setIsLock(IsLocked);
    setIdmCredentialTrackingId(IDMCredentialTrackingId);
    setTicketType(
      optionTicketType.find((item) => item.name === TicketType) || {
        name: "",
        color: "",
      },
    );
    setImpacted(Impacted);
    setAskNowRITM(AskNowTicketNumber);
    setOpenedTAHC(OpenedBy_TA_HC ? "Yes" : "No");
    setSelectedSwitchType(
      switchType.find((item) => item?.IDMSwitchTypeId === IDMSwitchTypeId) ||
        null,
    );
    setTtecSwitchIdDate(TtecSwitchIdDate);
    setEmailDate(EmailDate);
    setNonAutomatedQmsDate(NonAutomatedQMSDate);
    setNtLoginIsuDate(NTLoginISUCompletionDate);
    setClientSwitchSubmissionDate(ClientSwitchSubmissionDate);
    setClientAccessCalDate(ClientAccessCalculationDate);
    setDateCheckedByTl(DateCheckedByTL);
    setClientIDSubmissionDate(ClientIdSubmissionDate);
    setClientIDCompletionDate(ClientIdCompletionDate);
    setClientSwitchCompletionDate(ClientSwitchCompletionDate);
    setNotes(Notes);
    setIdmChecklistURL(IDMCredentialTrackingURL || "");
    setSelectedsystemImpacted(
      systemImpacted.filter((item) =>
        systemImpactedIdList.includes(item?.IDMSystemImpactedId.toString()),
      ),
    );
    setSelectedIssueDescription(
      issueDescription.filter((item) =>
        issueDescriptionIdList.includes(item?.IDMIssueDescriptionId.toString()),
      ),
    );
    setSelectedSanityCheckNotes(
      sanityCheckNotes.filter((item) =>
        sanityCheckNotesIds.includes(item?.IDMSanityCheckNotesId.toString()),
      ),
    );
  };

  useEffect(() => {
    const initialize = () => {
      setLoading(true);

      applicationUsageLog(
        localStorage.getItem("User"),
        localStorage.getItem("EmailId"),
        "OnboardingInformation",
        "IDM Credential Tracking",
      );

      setLoading(false);
    };

    initialize();
  }, []);

  useEffect(() => {
    // idmRosterDetails can be `{}` when the roster-details fetch failed
    // upstream (e.g. the record's assigned project has no OBTManagementInfo
    // entry). `{}` is truthy, so a plain `if (idmRosterDetails)` check would
    // treat that failure as "has no class roster" (ClassRosterId === 0 is
    // false for undefined too, so isNoClassRosterId incorrectly flips to
    // false) and render an empty Class Roster panel. Require an actual
    // identifying field before trusting this as real data.
    const hasRosterData =
      idmRosterDetails &&
      Object.prototype.hasOwnProperty.call(idmRosterDetails, "IDMCredentialTrackingId");
    if (hasRosterData) {
      setClassRosterDetails(idmRosterDetails);
      setIsNoClassRosterId(idmRosterDetails.ClassRosterId === 0);
      setDisableIsNoClassRosterId(idmRosterDetails.ClassRosterId === 0);
    }
    if (idmTrackingDetails) {
      setUpIdmCredentialFields(idmTrackingDetails);
    }
  }, [idmRosterDetails, idmTrackingDetails]);

  //show/hide tooltip
  const handleMouseEnter = (id) => {
    if (id === "Site") {
      setIsSiteTooltipOpen(true);
    } else if (id === "Client") {
      setIsClientTooltipOpen(true);
    } else if (id === "Project") {
      setIsProjectTooltipOpen(true);
    } else if (id === "AskNowTDT") {
      setIsAskNowTooltipOpen(true);
    }
  };

  const handleMouseLeave = (id) => {
    if (id === "Site") {
      setIsSiteTooltipOpen(false);
    } else if (id === "Client") {
      setIsClientTooltipOpen(false);
    } else if (id === "Project") {
      setIsProjectTooltipOpen(false);
    } else if (id === "AskNowTDT") {
      setIsAskNowTooltipOpen(false);
    }
  };

  const handleCancel = () => {
    handleReset();
    handleClose(false);
  };

  const toggleFullScreen = () => {
    setIsFullScreen((prev) => !prev);
  };

  const handleLock = async () => {
    setLoading(true);
    const payload = {
      IDMCredentialTrackingId: idmCredentialTrackingId,
      IsLocked: isLock === true ? 0 : 1, //If Locked then unlock else lock
      ModifiedBy: localStorage.getItem("User"),
    };

    const response = await IdmCredentialLock(payload);
    if (response?.message === "Success") {
      showSnack("Lock updated successfully", "success");
      setLoading(false);
      setIsLock((prev) => !prev);
    } else {
      showSnack("Internal Error occured", "error");
    }
    setLoading(false);
  };

  const handleTextChange = (event, key) => {
    if (key === "impacted") {
      setImpacted(event.target.value);
    } else if (key === "askNowRITM") {
      setAskNowRITM(event.target.value);
    }
  };

  const handleDateChange = (event, key) => {
    if (key === "emailDate") {
      setEmailDate(event.target.value);
    } else if (key === "nonAutomatedQmsDate") {
      setNonAutomatedQmsDate(event.target.value);
    } else if (key === "ntLoginIsuDate") {
      setNtLoginIsuDate(event.target.value);
    } else if (key === "clientSwitchSubmissionDate") {
      setClientSwitchSubmissionDate(event.target.value);
    } else if (key === "clientAccessCalDate") {
      setClientAccessCalDate(event.target.value);
    } else if (key === "dateCheckedByTl") {
      setDateCheckedByTl(event.target.value);
    } else if (key === "clientIDSubmissionDate") {
      setClientIDSubmissionDate(event.target.value);
    } else if (key === "clientIDCompletionDate") {
      setClientIDCompletionDate(event.target.value);
    } else if (key === "clientSwitchCompletionDate") {
      setClientSwitchCompletionDate(event.target.value);
    } else if (key === "ttecSwitchIdDate") {
      setTtecSwitchIdDate(event.target.value);
    }
  };

  const handleTextAreaChange = (e, setStateMethod) => {
    setStateMethod(e.target.value);
  };

  const handleAutocompleteChange = (event, value, key) => {
    if (key === "ticketType") {
      setTicketType(value === null ? { name: "", color: "" } : value);
    } else if (key === "openedByTAHC") {
      if (value === null) {
        setOpenedTAHC(null);
      } else {
        setOpenedTAHC(value);
      }
    } else if (key === "switchType") {
      setSelectedSwitchType(value);
    } else if (key === "systemImpacted") {
      setSelectedsystemImpacted(value);
    } else if (key === "issueDescription") {
      setSelectedIssueDescription(value);
    } else if (key === "sanityCheckNotes") {
      setSelectedSanityCheckNotes(value);
    }
  };

  const handleRosterChange = async (event, value) => {
    if (value != null && value !== "") {
      setLoading(true);
      await fetchRosterDetails(value);
      setLoading(false);
    } else {
      handleReset();
    }
  };

  const fetchRosterDetails = async (value) => {
    setLoading(true);
    setSelectedRosterId(value);
    const classRosterDetails = await getIdmRosterDetail(value.ClassRosterId);
    if (classRosterDetails?.message === "Success") {
      setClassRosterDetails(classRosterDetails?.data?.[0] || {});
    }
    setLoading(false);
  };

  const prepareUpdatePayload = () => ({
    IdmCredentialTrackingId: idmCredentialTrackingId,
    IdmCredentialDetails: prepareInsertPayload(),
  });

  const prepareInsertPayload = () => ({
    classRosterId:
      isNoClassRosterId === true ? 0 : selectedRosterId?.ClassRosterId,
    siteCode: rosterDetails.selectedSite?.GeoLocCd || "",
    clientCode: rosterDetails.selectedClient?.ClientCode || "",
    projectCodes:
      rosterDetails.selectedProjects
        ?.map((item) => item?.ProjectCode)
        .join(",") || "",
    headCount: rosterDetails.headCount || 0,
    technologyDeploymentTypeId:
      rosterDetails.selectedTechDeploymentType?.AskNowTDTId || 0,
    rosterLockDate: rosterDetails.rosterLockDate || moment(),
    trainingStartDate: rosterDetails.trainingStartDate || moment(),
    ticketType: ticketType?.name || "",
    openedByTaHc: openedTAHC === "Yes",
    emailDate: emailDate || null,
    nonAutomatedQmsDate: nonAutomatedQmsDate || null,
    askNowRITM: askNowRITM || "",
    ntLoginIsuDate: ntLoginIsuDate || null,
    switchType: selectedSwitchType?.IDMSwitchTypeId || null,
    ttecSwitchIdDate: ttecSwitchIdDate || null,
    clientIDSubmissionDate: clientIDSubmissionDate || null,
    clientIDCompletionDate: clientIDCompletionDate || null,
    clientSwitchSubmissionDate: clientSwitchSubmissionDate || null,
    clientSwitchCompletionDate: clientSwitchCompletionDate || null,
    clientAccessCalDate: clientAccessCalDate || null,
    dateCheckedByTl: dateCheckedByTl || null,
    systemImpacted:
      selectedsystemImpacted.length > 0
        ? selectedsystemImpacted.map((item) => ({
            systemImpactedId: item?.IDMSystemImpactedId || null,
          }))
        : [{ systemImpactedId: null }],

    issueDescription:
      selectedIssueDescription.length > 0
        ? selectedIssueDescription.map((item) => ({
            issueDescriptionId: item?.IDMIssueDescriptionId || null,
          }))
        : [{ issueDescriptionId: null }],

    sanityCheckNotes:
      selectedSanityCheckNotes.length > 0
        ? selectedSanityCheckNotes.map((item) => ({
            sanityCheckNotesId: item?.IDMSanityCheckNotesId || null,
          }))
        : [{ sanityCheckNotesId: null }],
    impacted: impacted || 0,
    notes: notes || "",
    createdBy: localStorage.getItem("User") || "",
  });

  const checkForEmptyFields = (value) =>
    value === null || value === "" || value === undefined;

  const validateRosterDetails = () => {
    if (checkForEmptyFields(rosterDetails.selectedSite)) {
      showSnack("Please select Site.", "error");
      return false;
    } else if (checkForEmptyFields(rosterDetails.selectedClient)) {
      showSnack("Please select Client.", "error");
      return false;
    } else if (
      rosterDetails.selectedProjects === undefined ||
      rosterDetails.selectedProjects.length === 0
    ) {
      showSnack("Please select Project.", "error");
      return false;
    } else if (
      rosterDetails.headCount === undefined ||
      rosterDetails.headCount === null ||
      rosterDetails.headCount === 0 ||
      rosterDetails.headCount == "0" ||
      rosterDetails.headCount == "" ||
      isNaN(rosterDetails.headCount)
    ) {
      showSnack("Please enter HeadCount.", "error");
      return false;
    } else if (checkForEmptyFields(rosterDetails.selectedTechDeploymentType)) {
      showSnack("Please select Technology Deployment Type.", "error");
      return false;
    } else if (checkForEmptyFields(rosterDetails.rosterLockDate)) {
      showSnack("Please select Roster Locked Date.", "error");
      return false;
    } else if (checkForEmptyFields(rosterDetails.trainingStartDate)) {
      showSnack("Please select Training Start Date.", "error");
      return false;
    }
    return true;
  };

  // Helper function to validate class roster
  const validateClassRoster = (
    isNoClassRosterId,
    selectedRosterId,
    showSnack,
  ) => {
    if (
      isNoClassRosterId === false &&
      (selectedRosterId === 0 || selectedRosterId?.ClassRosterId === undefined)
    ) {
      showSnack("Please select a class roster.", "error");
      return false;
    }
    return true;
  };

  // Helper function to validate roster details for no class roster case
  const validateNoClassRosterDetails = (
    isNoClassRosterId,
    validateRosterDetails,
  ) => {
    if (isNoClassRosterId === true && !validateRosterDetails()) {
      return false;
    }
    return true;
  };

  // Helper function to validate ticket type
  const validateTicketType = (ticketType, showSnack) => {
    if (ticketType === null || ticketType.name === "") {
      showSnack("Please select a ticket type.", "error");
      return false;
    }
    return true;
  };

  // Helper function to validate AskNow RITM
  const validateAskNowRITM = (askNowRITM, showSnack) => {
    if (askNowRITM === null || askNowRITM === "" || askNowRITM === undefined) {
      showSnack("Please enter AskNow RITM.", "error");
      return false;
    }

    const regexForRITM = /^[a-zA-Z0-9]+$/;
    if (!regexForRITM.test(askNowRITM)) {
      showSnack("Please enter a valid AskNow RITM.", "error");
      return false;
    }

    return true;
  };

  // Helper function to validate opened by TA/HC
  const validateOpenedTAHC = (openedTAHC, showSnack) => {
    if (openedTAHC === null || openedTAHC === "") {
      showSnack("Please select Opened by TA/HC.", "error");
      return false;
    }
    return true;
  };

  // Helper function to validate all inputs
  const validateAllInputs = (
    isNoClassRosterId,
    selectedRosterId,
    validateRosterDetails,
    ticketType,
    askNowRITM,
    openedTAHC,
    showSnack,
  ) => {
    if (!validateClassRoster(isNoClassRosterId, selectedRosterId, showSnack)) {
      return false;
    }

    if (
      !validateNoClassRosterDetails(isNoClassRosterId, validateRosterDetails)
    ) {
      return false;
    }

    if (!validateTicketType(ticketType, showSnack)) {
      return false;
    }

    if (!validateAskNowRITM(askNowRITM, showSnack)) {
      return false;
    }

    if (!validateOpenedTAHC(openedTAHC, showSnack)) {
      return false;
    }

    return true;
  };

  // Helper function to execute API call based on mode
  const executeApiCall = async (
    isUpdateMode,
    prepareUpdatePayload,
    prepareInsertPayload,
    isNoClassRosterId,
    setLoading,
  ) => {
    setLoading(true);

    let response;
    if (isUpdateMode) {
      const payload = prepareUpdatePayload();
      response = await updateIdmCredential(payload);
    } else {
      const payload = prepareInsertPayload();
      response = await insertIdmCredential(payload, isNoClassRosterId);
    }

    setLoading(false);
    return response;
  };

  // Helper function to handle successful response
  const handleSuccessfulResponse = (
    response,
    isUpdateMode,
    setIdmCredentialTrackingId,
    setLoading,
    showSnack,
    handleReset,
    handleClose,
  ) => {
    setIdmCredentialTrackingId(response?.data[0]?.IDMCredentialTrackingId);
    setLoading(false);
    showSnack(
      `Idm Credential ${isUpdateMode ? "updated" : "created"} successfully`,
      "success",
    );
    handleReset();
    handleClose(true);
  };

  // Helper function to handle failed response
  const handleFailedResponse = (setLoading, showSnack) => {
    setLoading(false);
    showSnack("Internal Error, please try again!", "error");
  };

  // Refactored main function
  const onSubmit = async () => {
    if (
      !validateAllInputs(
        isNoClassRosterId,
        selectedRosterId,
        validateRosterDetails,
        ticketType,
        askNowRITM,
        openedTAHC,
        showSnack,
      )
    ) {
      return;
    }

    try {
      const response = await executeApiCall(
        isUpdateMode,
        prepareUpdatePayload,
        prepareInsertPayload,
        isNoClassRosterId,
        setLoading,
      );

      if (response.message === "Success") {
        handleSuccessfulResponse(
          response,
          isUpdateMode,
          setIdmCredentialTrackingId,
          setLoading,
          showSnack,
          handleReset,
          handleClose,
        );
      } else {
        handleFailedResponse(setLoading, showSnack);
      }
    } catch (error) {
      handleFailedResponse(setLoading, showSnack);
    }
  };

  const handleReset = () => {
    setClassRosterDetails([]);
    setIdmCredentialTrackingId(0);
    setTicketType({ name: "", color: "" });
    setImpacted(0);
    setAskNowRITM("");
    setSelectedSwitchType(null);
    setSelectedsystemImpacted([]);
    setSelectedIssueDescription([]);
    setSelectedSanityCheckNotes([]);
    setEmailDate(null);
    setNonAutomatedQmsDate(null);
    setNtLoginIsuDate(null);
    setClientSwitchSubmissionDate(null);
    setClientAccessCalDate(null);
    setDateCheckedByTl(null);
    setClientIDSubmissionDate(null);
    setClientIDCompletionDate(null);
    setClientSwitchCompletionDate(null);
    setTtecSwitchIdDate(null);
    setSelectedRosterId(0);
  };

  const unSavedDataExist = () => {
    return (
      !checkForEmptyFields(rosterDetails.selectedSite) ||
      !checkForEmptyFields(rosterDetails.selectedClient) ||
      (rosterDetails.selectedProjects !== undefined &&
        rosterDetails.selectedProjects.length > 0) ||
      (rosterDetails.headCount !== undefined &&
        rosterDetails.headCount !== null &&
        rosterDetails.headCount !== 0 &&
        rosterDetails.headCount != "0" &&
        rosterDetails.headCount != "") ||
      !checkForEmptyFields(rosterDetails.selectedTechDeploymentType) ||
      !checkForEmptyFields(rosterDetails.rosterLockDate) ||
      !checkForEmptyFields(rosterDetails.trainingStartDate)
    );
  };

  const handleIsNoClassRosterIdChange = () => {
    if (isNoClassRosterId && unSavedDataExist()) {
      setUnSavedRosterChangesDialogOpen(true);
    } else {
      setIsNoClassRosterId(!isNoClassRosterId);
    }
  };

  return (
    <>
      <Dialog
        maxWidth={isFullScreen ? false : "xl"}
        fullScreen={isFullScreen}
        open={idmRecordOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            return;
          }
          handleClose(false);
        }}
        disableEscapeKeyDown
      >
        {loading && <BackdropComponent />}
        <Grid container padding={1}>
          <Grid item xs={4}>
            <DialogTitle>
              <Typography
                sx={{
                  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                  fontSize: 18,
                  fontWeight: "bold",
                  color: "#3F5765",
                  letterSpacing: "0.10em",
                }}
              >
                IDM Credential Tracking
              </Typography>
            </DialogTitle>
          </Grid>
          <Grid item xs={8} sx={{ pt: 2 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              {(!isUpdateMode ||
                (isUpdateMode && disableIsNoClassRosterId)) && (
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "#3299FF",
                        "&.Mui-disabled": {
                          color: blue[200],
                        },
                      }}
                      checked={isNoClassRosterId}
                      disabled={disableIsNoClassRosterId}
                      onChange={handleIsNoClassRosterIdChange}
                    />
                  }
                  label="No Class Roster ID"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontWeight: "bold",
                      fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                      pl: 1,
                      color: "#3F5765",
                      letterSpacing: "0.10em",
                    },
                    "&.Mui-disabled": {
                      color: "#3F5765",
                      "-webkit-text-fill-color": "#3F5765",
                    },
                  }}
                />
              )}
              {isUpdateMode && isEdit && (
                <IconButton onClick={handleLock}>
                  {isLock ? (
                    <LockOutlinedIcon sx={{ fontSize: 30, color: "#EC6517" }} />
                  ) : (
                    <LockOpenOutlinedIcon
                      sx={{ fontSize: 30, color: "#3299FF" }}
                    />
                  )}
                </IconButton>
              )}
              <CustomButton
                variant="contained"
                sx={{ backgroundColor: "#3299FF" }}
                startIcon={
                  isUpdateMode ? (
                    <EditOutlinedIcon sx={{ fontSize: "12px" }} />
                  ) : (
                    <AddCircleOutlineIcon sx={{ fontSize: "12px" }} />
                  )
                }
                disabled={isLock || !isEdit}
                onClick={onSubmit}
              >
                {isUpdateMode > 0 ? "Update" : "Save"}
              </CustomButton>
              <CustomButton
                sx={{ backgroundColor: "#3299FF" }}
                variant="contained"
                startIcon={
                  isFullScreen ? (
                    <SouthEastOutlinedIcon sx={{ fontSize: "12px" }} />
                  ) : (
                    <NorthWestOutlinedIcon sx={{ fontSize: "12px" }} />
                  )
                }
                onClick={() => toggleFullScreen()}
              >
                {isFullScreen ? "Compress" : "Expand"}
              </CustomButton>
              <IconButton onClick={handleCancel} sx={{ alignSelf: "center" }}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
        <ThemeProvider theme={ReadOnlyTextFieldtheme}>
          {isNoClassRosterId ? (
            <NoRosterIdCreateUpdateIdmRecord
              isEdit={isUpdateMode}
              rosterDetails={classRosterDetails}
              updateRosterDetails={(value) => setRosterDetails(value)}
              idmChecklistURL={idmChecklistURL}
            />
          ) : (
            <>
              <Divider sx={{ px: 3 }}>Read Only Fields</Divider>
              <Grid container spacing={2} padding={3}>
                <Grid item xs={3}>
                  <Autocomplete
                    disablePortal
                    value={selectedRosterId}
                    options={rosterId}
                    readOnly={isUpdateMode}
                    onChange={handleRosterChange}
                    getOptionLabel={(option) =>
                      option?.ClassRosterId?.toString() || ""
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        label={
                          <span>
                            Select Class Roster Id &nbsp;
                            <Box component={"span"} sx={{ color: red[700] }}>
                              *
                            </Box>
                          </span>
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Tooltip
                    title={classRosterDetails.SiteName}
                    disableInteractive
                    open={isSiteTooltipOpen}
                    onClose={() => handleMouseLeave("Site")}
                    onOpen={() => handleMouseEnter("Site")}
                  >
                    <TextField
                      label="Site"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={classRosterDetails.SiteName || "NA"}
                      disabled
                      onMouseEnter={() => handleMouseEnter("Site")}
                      onMouseLeave={() => handleMouseLeave("Site")}
                    />
                  </Tooltip>
                </Grid>
                <Grid item xs={3}>
                  <Tooltip
                    title={classRosterDetails.ClientName}
                    disableInteractive
                    open={isClientTooltipOpen}
                    onClose={() => handleMouseLeave("Client")}
                    onOpen={() => handleMouseEnter("Client")}
                  >
                    <TextField
                      label="Client"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={classRosterDetails.ClientName || "NA"}
                      disabled
                      onMouseEnter={() => handleMouseEnter("Client")}
                      onMouseLeave={() => handleMouseLeave("Client")}
                    />
                  </Tooltip>
                </Grid>
                <Grid item xs={3}>
                  <Tooltip
                    title={classRosterDetails.Project}
                    disableInteractive
                    open={isProjectTooltipOpen}
                    onClose={() => handleMouseLeave("Project")}
                    onOpen={() => handleMouseEnter("Project")}
                  >
                    <TextField
                      label="Project"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={classRosterDetails.Project || "NA"}
                      disabled
                      onMouseEnter={() => handleMouseEnter("Project")}
                      onMouseLeave={() => handleMouseLeave("Project")}
                    />
                  </Tooltip>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    label="HeadCount"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={classRosterDetails.NumberOfAssignedTrainees || "NA"}
                    disabled
                  />
                </Grid>
                <Grid item xs={3}>
                  <Tooltip
                    title={classRosterDetails.AskNowTDT}
                    disableInteractive
                    open={isAskNowTooltipOpen}
                    onClose={() => handleMouseLeave("AskNowTDT")}
                    onOpen={() => handleMouseEnter("AskNowTDT")}
                  >
                    <TextField
                      label="Technology Deployment Type"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={classRosterDetails.AskNowTDT || "NA"}
                      disabled
                      onMouseEnter={() => handleMouseEnter("AskNowTDT")}
                      onMouseLeave={() => handleMouseLeave("AskNowTDT")}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    label="Roster Locked Date"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={
                      classRosterDetails.RosterLockDate?.split("T")[0] || "NA"
                    }
                    disabled
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    label="Training Start Date"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={
                      classRosterDetails.ProductTrainingDate?.split("T")[0] +
                        classRosterDetails.ProductTrainingTime || "NA"
                    }
                    disabled
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    label="IDM Team Lead"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={classRosterDetails.IDMTeamLead || "NA"}
                    disabled
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    label="Primary IDM POC"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={classRosterDetails.PrimaryIDMPOC || "NA"}
                    disabled
                  />
                </Grid>
                <Grid
                  item
                  xs={3}
                  sx={{
                    textAlign: "left",
                    fontWeight: "bold",
                    marginLeft: 1,
                  }}
                >
                  {idmChecklistURL.length > 0 && (
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <Tooltip title="IDM Checklist">
                        {isEdit && (
                          <Link
                            href={idmChecklistURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              display: "flex",
                              alignItems: "flex-end",
                              textDecoration: "none",
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: "Urbanist, sans-serif",
                                fontWeight: "bold",
                              }}
                            >
                              IDM Checklist
                            </Typography>
                            <SimCardDownloadOutlinedIcon
                              sx={{ fontSize: "2rem" }}
                            />
                          </Link>
                        )}
                      </Tooltip>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </>
          )}
        </ThemeProvider>
        <Divider sx={{ px: 3 }}>Input Fields</Divider>
        <Grid container spacing={2} padding={3}>
          <Grid item xs={3}>
            <Autocomplete
              disablePortal
              freeSolo
              openOnFocus
              value={ticketType}
              options={optionTicketType}
              getOptionLabel={(option) => option.name}
              onChange={(event, value) =>
                handleAutocompleteChange(event, value, "ticketType")
              }
              renderOption={(props, option) => (
                <Box
                  component="li"
                  {...props}
                  display="flex"
                  alignItems="center"
                >
                  <Box
                    component="span"
                    sx={{
                      width: 10,
                      height: 10,
                      backgroundColor: option.color,
                      marginRight: 1,
                    }}
                  />
                  {option.name}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Ticket Type"
                  label={
                    <span>
                      Ticket Type
                      <Box component={"span"} sx={{ color: red[700] }}>
                        *
                      </Box>
                    </span>
                  }
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        {params.inputProps.value && (
                          <Box
                            component="span"
                            sx={{
                              width: 10,
                              height: 10,
                              backgroundColor: optionTicketType.find(
                                (option) =>
                                  option.name === params.inputProps.value,
                              )?.color,
                              marginLeft: 1,
                            }}
                          />
                        )}
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={3}>
            <Autocomplete
              disablePortal
              freeSolo
              openOnFocus
              options={optionYesNo}
              value={openedTAHC}
              onChange={(event, value) =>
                handleAutocompleteChange(event, value, "openedByTAHC")
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Opened by TA/HC"
                  label={
                    <span>
                      Opened by TA/HC
                      <Box component={"span"} sx={{ color: red[700] }}>
                        *
                      </Box>
                    </span>
                  }
                />
              )}
            />
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TextField
                label="Email Submission"
                variant="outlined"
                className={classes.Container}
                type="datetime-local"
                size="small"
                value={emailDate || ""}
                fullWidth
                onChange={(event) => handleDateChange(event, "emailDate")}
                onKeyDown={(event) =>
                  handleDateChange(
                    event.key === "Backspace" ? "" : event.target.value,
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TextField
                label="Non-Automated QMS"
                variant="outlined"
                className={classes.Container}
                type="datetime-local"
                size="small"
                value={nonAutomatedQmsDate || ""}
                fullWidth
                onChange={(event) =>
                  handleDateChange(event, "nonAutomatedQmsDate")
                }
                onKeyDown={(event) =>
                  handleDateChange(
                    event.key === "Backspace" ? "" : event.target.value,
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <TextField
              variant="outlined"
              label={
                <span>
                  AskNow RITM{" "}
                  <Box component={"span"} sx={{ color: red[700] }}>
                    *
                  </Box>
                </span>
              }
              size="small"
              fullWidth
              value={askNowRITM || ""}
              placeholder="Max 100 characters allowed"
              onChange={(event) => handleTextChange(event, "askNowRITM")}
              inputProps={{
                maxLength: 100,
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TextField
                variant="outlined"
                label=" NT Login/ISU Completion"
                className={classes.Container}
                type="datetime-local"
                size="small"
                value={ntLoginIsuDate || ""}
                fullWidth
                onChange={(event) => handleDateChange(event, "ntLoginIsuDate")}
                onKeyDown={(event) =>
                  handleDateChange(
                    event.key === "Backspace" ? "" : event.target.value,
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <Autocomplete
              disablePortal
              freeSolo
              openOnFocus
              value={selectedSwitchType}
              options={switchType}
              getOptionLabel={(option) =>
                option?.SwitchType === "" ? "" : option?.SwitchType
              }
              onChange={(event, value) =>
                handleAutocompleteChange(event, value, "switchType")
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Select"
                  label="Switch Type"
                />
              )}
            />
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TextField
                variant="outlined"
                label="TTEC Switch ID Completion"
                className={classes.Container}
                type="datetime-local"
                size="small"
                value={ttecSwitchIdDate || ""}
                fullWidth
                onChange={(event) =>
                  handleDateChange(event, "ttecSwitchIdDate")
                }
                onKeyDown={(event) =>
                  handleDateChange(
                    event.key === "Backspace" ? "" : event.target.value,
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TextField
                variant="outlined"
                label="Client ID Submission"
                className={classes.Container}
                type="datetime-local"
                size="small"
                value={clientIDSubmissionDate || ""}
                fullWidth
                onChange={(event) =>
                  handleDateChange(event, "clientIDSubmissionDate")
                }
                onKeyDown={(event) =>
                  handleDateChange(
                    event.key === "Backspace" ? "" : event.target.value,
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TextField
                variant="outlined"
                label="Client IDs Completion"
                className={classes.Container}
                type="datetime-local"
                size="small"
                value={clientIDCompletionDate || ""}
                fullWidth
                onChange={(event) =>
                  handleDateChange(event, "clientIDCompletionDate")
                }
                onKeyDown={(event) =>
                  handleDateChange(
                    event.key === "Backspace" ? "" : event.target.value,
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TextField
                variant="outlined"
                label="Client Switch Submission (date)"
                className={classes.Container}
                type="datetime-local"
                size="small"
                value={clientSwitchSubmissionDate || ""}
                fullWidth
                onChange={(event) =>
                  handleDateChange(event, "clientSwitchSubmissionDate")
                }
                onKeyDown={(event) =>
                  handleDateChange(
                    event.key === "Backspace" ? "" : event.target.value,
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TextField
                variant="outlined"
                label="Client Switch Completion"
                className={classes.Container}
                type="datetime-local"
                size="small"
                value={clientSwitchCompletionDate || ""}
                fullWidth
                onChange={(event) =>
                  handleDateChange(event, "clientSwitchCompletionDate")
                }
                onKeyDown={(event) =>
                  handleDateChange(
                    event.key === "Backspace" ? "" : event.target.value,
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TextField
                variant="outlined"
                label="Client Access Calculation"
                className={classes.Container}
                type="datetime-local"
                size="small"
                value={clientAccessCalDate || ""}
                fullWidth
                onChange={(event) =>
                  handleDateChange(event, "clientAccessCalDate")
                }
                onKeyDown={(event) =>
                  handleDateChange(
                    event.key === "Backspace" ? "" : event.target.value,
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TextField
                variant="outlined"
                label="Date Checked by TL"
                className={classes.Container}
                type="datetime-local"
                size="small"
                value={dateCheckedByTl || ""}
                fullWidth
                onChange={(event) => handleDateChange(event, "dateCheckedByTl")}
                onKeyDown={(event) =>
                  handleDateChange(
                    event.key === "Backspace" ? "" : event.target.value,
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <Autocomplete
              disablePortal
              multiple
              limitTags={1}
              size="small"
              value={selectedsystemImpacted}
              options={systemImpacted}
              getOptionLabel={(option) => option.SystemImpacted}
              onChange={(event, value) =>
                handleAutocompleteChange(event, value, "systemImpacted")
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  placeholder="System Impacted"
                  label="System Impacted"
                />
              )}
              renderTags={(value, getTagProps) => {
                const limitTags = 1;
                const more = value.length - limitTags;
                return (
                  <>
                    {value.slice(0, limitTags).map((option, index) => (
                      <StyledChip
                        label={option.SystemImpacted}
                        size="small"
                        {...getTagProps({ index })}
                      />
                    ))}
                    {more > 0 && <LimitChip label={`+${more}`} size="small" />}
                  </>
                );
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              label="# Impacted"
              variant="outlined"
              size="small"
              fullWidth
              value={impacted}
              onChange={(event) => handleTextChange(event, "impacted")}
              inputProps={{ type: "number" }}
              placeholder="Number only"
            />
          </Grid>
          <Grid item xs={3}>
            <Autocomplete
              disablePortal
              multiple
              limitTags={1}
              size="small"
              value={selectedIssueDescription}
              options={issueDescription}
              getOptionLabel={(option) => option.IssueDescription}
              onChange={(event, value) =>
                handleAutocompleteChange(event, value, "issueDescription")
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  placeholder="Issue Description"
                  label="Issue Description"
                />
              )}
              renderTags={(value, getTagProps) => {
                const limitTags = 1;
                const more = value.length - limitTags;
                return (
                  <>
                    {value.slice(0, limitTags).map((option, index) => (
                      <StyledChip
                        label={option.IssueDescription}
                        size="small"
                        {...getTagProps({ index })}
                      />
                    ))}
                    {more > 0 && <LimitChip label={`+${more}`} size="small" />}
                  </>
                );
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <Autocomplete
              disablePortal
              multiple
              limitTags={1}
              size="small"
              value={selectedSanityCheckNotes}
              options={sanityCheckNotes}
              getOptionLabel={(option) => option.SanityCheckNotes}
              onChange={(event, value) =>
                handleAutocompleteChange(event, value, "sanityCheckNotes")
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Sanity Check Notes"
                  label="Sanity Check Notes"
                />
              )}
              renderTags={(value, getTagProps) => {
                const limitTags = 1;
                const more = value.length - limitTags;
                return (
                  <>
                    {value.slice(0, limitTags).map((option, index) => (
                      <StyledChip
                        label={option.SanityCheckNotes}
                        size="small"
                        {...getTagProps({ index })}
                      />
                    ))}
                    {more > 0 && <LimitChip label={`+${more}`} size="small" />}
                  </>
                );
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              multiline
              name="Notes"
              value={notes}
              rows={3}
              label="Notes"
              placeholder="Add Notes (Max 2000 characters allowed)"
              helperText={`${notes ? notes.length : 0}/${2000}`}
              inputProps={{ maxLength: 2000 }}
              onChange={(event) => handleTextAreaChange(event, setNotes)}
              FormHelperTextProps={{
                sx: {
                  position: "absolute",
                  bottom: 8,
                  right: 8,
                },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            {isUpdateMode === true && (
              <Grid container>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Typography
                      sx={{
                        fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                        fontWeight: "bold",
                        color: "#3F5765",
                        letterSpacing: "0.10em",
                        fontSize: 12,
                        marginTop: 0.75,
                        marginBottom: 0.75,
                      }}
                    >
                      Tracking ID :
                    </Typography>
                    {idmTrackingDetails?.IDMCredentialTrackingId
                      ? idmTrackingDetails?.IDMCredentialTrackingId
                      : "N/A"}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Typography
                      sx={{
                        fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                        fontWeight: "bold",
                        color: "#3F5765",
                        letterSpacing: "0.10em",
                        fontSize: 12,
                        marginTop: 0.75,
                        marginBottom: 0.75,
                      }}
                    >
                      Last Modified By:
                    </Typography>
                    {idmTrackingDetails?.ModifiedBy
                      ? idmTrackingDetails?.ModifiedBy
                      : "N/A"}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Typography
                      sx={{
                        fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                        fontWeight: "bold",
                        color: "#3F5765",
                        letterSpacing: "0.10em",
                        fontSize: 12,
                        marginTop: 0.75,
                        marginBottom: 0.75,
                      }}
                    >
                      Last Modified Date:
                    </Typography>
                    {idmTrackingDetails?.ModifiedDate
                      ? moment(idmTrackingDetails?.ModifiedDate).format(
                          "MM/DD/YYYY HH:mm",
                        )
                      : "N/A"}
                  </Box>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>

        {/* ServiceNow Section - NEW INTEGRATION */}
        {window.location.host !== "astt.ttec.com" && (
          <Box sx={{ px: 3, pb: 3 }}>
            <ServiceNowSection ritmNumber={askNowRITM} />
          </Box>
        )}
      </Dialog>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
      <Dialog
        open={unSavedRosterChangesDialogOpen}
        onClose={() => setUnSavedRosterChangesDialogOpen(false)}
        TransitionComponent={Transition}
        sx={{
          "& .MuiDialog-paper": {
            minWidth: "330px",
          },
        }}
      >
        {loading ? <BackdropComponent /> : null}
        <DialogTitle>
          <Grid container>
            <Grid item xs={1.5}>
              <WarningIcon fontSize="large" sx={{ color: "#3299FF" }} />
            </Grid>
            <Grid item xs={10.3} sx={{ pt: 0.5 }}>
              <Typography
                sx={{
                  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                  fontWeight: "bold",
                  color: "#3F5765",
                  letterSpacing: "0.10em",
                  fontSize: 14,
                }}
              >
                Unsaved changes
              </Typography>
            </Grid>
            <Grid item xs={0.2} sx={{ pt: 0.2 }}>
              <CloseIcon sx={{ color: "#3F5765" }} />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              fontFamily: "Urbanist, Verdana, Arial, sans-serif",
              color: "#3F5765",
              letterSpacing: "0.10em",
              fontSize: 12,
            }}
          >
            Changes will be lost, Do you want to proceed ?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-start" }}>
          <CustomButton
            variant="contained"
            sx={{ backgroundColor: "#3299FF" }}
            onClick={() => {
              setIsNoClassRosterId(!isNoClassRosterId);
              setUnSavedRosterChangesDialogOpen(false);
            }}
          >
            Proceed
          </CustomButton>

          <CustomButton
            sx={{ color: "#3299FF" }}
            variant="outlined"
            onClick={() => setUnSavedRosterChangesDialogOpen(false)}
          >
            Cancel
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

CreateUpdateIdmRecord.propTypes = {
  rosterId: PropTypes.array,
  switchType: PropTypes.array,
  sanityCheckNotes: PropTypes.array,
  issueDescription: PropTypes.array,
  idmRecordOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  trackingId: PropTypes.any,
  idmRosterDetails: PropTypes.any,
  idmTrackingDetails: PropTypes.any,
  systemImpacted: PropTypes.array,
};
